import Cookie from 'js-cookie'

export const getCookie = (name: string) => {
  return Cookie.get(name)
}

export const removeCookie = (name: string) => {
  Cookie.remove(name)
}
